import EDocumentImportWizard from "@components/content/EDocumentImportWizard";
import creditnoteImportDefinition from "@utils/edocumentImport/definitions/creditnoteImport";

/**
 * Carga masiva de notas de credito electronicas ya emitidas.
 *
 * Toda la logica vive en el asistente agnostico y en la definicion del documento: esta pagina
 * solo elige cual.
 */
const CreditnoteImport = () => <EDocumentImportWizard definition={creditnoteImportDefinition} />;

export default CreditnoteImport;
